module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vresp8-5207ddcfd0c417fe46d4218cd48e81a0.jpg";